import { useState } from "react";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import JisTabButton from "../../components/controls/jisTabButton";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import * as Constants from "../../constants";
import { AcrScheduleNewModal } from "../../components/post-judgement/ScheduleNewCase";

export const AcrPostJudgement = () => {
  const [tab, setTab] = useState("pendingCase");
  const [page, setPage] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  //   dummy data
  const eSwearingCases = [
    {
      id: 1,
      suitNumber: "ID/3885GCM/2025",
      caseTitle: "State of Lagos VS Salman Lukman",
      status: "Pending Oath",
      action: "View Doc",
      tab: "pendingCase",
    },
    {
      id: 2,
      suitNumber: "ID/3885GCM/2025",
      caseTitle: "State of Lagos VS Salman Lukman",
      status: "Pending Oath",
      action: "View Doc",
      tab: "pendingCase",
    },

    {
      id: 3,
      suitNumber: "ID/3885GCM/2025",
      caseTitle: "State of Lagos VS Salman Lukman",
      status: "Pending Oath",
      scheduleDate: "17 November, 2025",
      time: "12:30 PM",
      zoomLink: "Zoom Link",
      action: "View Doc",
      tab: "scheduled",
    },
    {
      id: 4,
      suitNumber: "ID/3885GCM/2025",
      caseTitle: "State of Lagos VS Salman Lukman",
      status: "Pending Oath",
      scheduleDate: "17 November, 2025",
      time: "12:30 PM",
      zoomLink: "Zoom Link",
      action: "View Doc",
      tab: "scheduled",
    },

    {
      id: 5,
      suitNumber: "ID/3885GCM/2025",
      caseTitle: "State of Lagos VS Salman Lukman",
      status: "Commissioned",
      scheduleDate: "11 July, 2025",
      action: "View Doc",
      tab: "commissioned",
    },
    {
      id: 6,
      suitNumber: "ID/3885GCM/2025",
      caseTitle: "State of Lagos VS Salman Lukman",
      status: "Commissioned",
      scheduleDate: "11 July, 2025",
      action: "View Doc",
      tab: "commissioned",
    },

    {
      id: 7,
      suitNumber: "ID/3885GCM/2025",
      caseTitle: "State of Lagos VS Salman Lukman",
      status: "Rework",
      action: "View Doc",
      scheduleDate: "17 November, 2025",
      tab: "rework",
    },
  ];
  const cases = eSwearingCases.filter((c) => c.tab === tab);

  const handleSearch = () => {
    // handle search
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };
  return (
    <div>
      <CustomSearchSortHeader
        onSearch={handleSearch}
        isSearchOnly
        isSearchAndDateOnly
      />
      <div className="tab-export-wrapper">
        <div className="tab_section ds-tab-container">
          <JisTabButton
            isActive={tab == "pendingCase"}
            title="Pending Cases"
            isRoleBased={false}
            onClick={() => setTab("pendingCase")}
          />
          <JisTabButton
            isActive={tab == "scheduled"}
            title="Scheduled"
            isRoleBased={false}
            onClick={() => setTab("scheduled")}
          />
          <JisTabButton
            isActive={tab == "commissioned"}
            title="Commissioned"
            isRoleBased={false}
            onClick={() => setTab("commissioned")}
          />
          <JisTabButton
            isActive={tab == "rework"}
            title="Rework"
            isRoleBased={false}
            onClick={() => setTab("rework")}
          />
        </div>
        <div className="exportdiv">
          <img src={wordicon} />
          <img src={excelicon} />
          <img src={pdficon} />
        </div>
      </div>
      <div className="tab_view">
        {cases?.length == 0 && <JisEmptyList />}
        {cases?.length > 0 && (
          <div className="table">
            <div class="section-cases">
              <span>E-Swearing Cases</span>
            </div>
            <div className="table-wrapper">
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th>Status</th>

                    {(tab === "scheduled" || tab === "pendingCase") && (
                      <>
                        <th className="col-medium">Schedule Date</th>
                        <th>Time</th>
                        <th className="col-title">Zoom Link</th>
                      </>
                    )}

                    {(tab === "commissioned" || tab === "rework") && (
                      <th>Date</th>
                    )}

                    <th className="col-action">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {cases.map((opt, index) => (
                    <tr key={index}>
                      <td>{opt.suitNumber}</td>
                      <td>{opt.caseTitle}</td>
                      <td>{opt.status}</td>

                      {(tab === "scheduled" || tab === "pendingCase") && (
                        <>
                          <td>{opt.scheduleDate || "-"}</td>
                          <td>{opt.time || "-"}</td>
                          <td>
                            {opt.zoomLink ? (
                              <a
                                style={{ color: "#5CA9FB" }}
                                href="#"
                                className="link"
                              >
                                {opt.zoomLink}
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                        </>
                      )}

                      {(tab === "commissioned" || tab === "rework") && (
                        <td>{Constants.formatDate(opt.scheduleDate)}</td>
                      )}

                      <td>
                        <a
                          style={{ color: "#5CA9FB" }}
                          href="#"
                          className="link"
                        >
                          {opt.action}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {cases?.length > 0 && (
              <Pagenated
                onChangePageSize={(k) => setPageSize(k)}
                size={pageSize}
                total={cases.length}
                maxPage={20}
                onPick={onPagePick}
              />
            )}
          </div>
        )}
      </div>

      {isScheduleModalOpen && (
        <AcrScheduleNewModal
          handleCancel={() => setIsScheduleModalOpen(false)}
        />
      )}
    </div>
  );
};
